import { render, staticRenderFns } from "./HighlightTagWrapper.vue?vue&type=template&id=d4538708&"
import script from "./HighlightTagWrapper.vue?vue&type=script&lang=js&"
export * from "./HighlightTagWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports